const HEART =
  "M74.77,349.55s74.77-51.58,74.77-95.89c0-21.47-17.09-39.64-38.88-39.64-12.47,0-24.21,5.99-31.52,16.09l-4.38,6.05-4.38-6.05c-7.3-10.11-19.04-16.09-31.52-16.09-21.76,0-38.88,18.17-38.88,39.64,0,44.31,74.77,95.89,74.77,95.89Z";

const MARK =
  "M445.07,222.17c-8.25,6.08-15.64,15.6-15.37,26.29v24.05h83.99v32.07h-83.99v77.8h-19.38c-12.46,0-22.49-9.91-22.49-22.38h-.01v-111.55c0-12.52,6.12-24.89,14.01-34.95,7.89-10.06,18.49-17.99,31.28-23.8,11.35-5.15,24.04-8,38.03-8.57h0s.04,0,.04,0c.05,0,.09,0,.14,0h0s71.58,0,71.58,0c0,0,0,0,0,0C502.37,75.23,399.85,0,279.71,0,182.53,0,94.28,53.65,43.39,128.96c-.01.01-.02.02-.03.04-1.12,1.52-6.94,10.38-7.74,12.11-1.66,3.59-2.59,7.58-2.59,11.8,0,15.55,12.6,28.22,28.14,28.23,0,0,173.92.03,174.6.04,15.26.25,29.02,3.11,41.23,8.65,12.78,5.8,23.12,13.73,31,23.8,7.89,10.06,12.55,21.72,14.01,34.95h-41.88c-1.82-10.7-6.85-19.08-15.1-25.16-8.25-6.07-18.54-9.11-30.87-9.11-11.42,0-21.4,2.68-29.92,8.02-8.52,5.35-15.14,13.01-19.85,22.98-4.72,9.97-7.07,21.94-7.07,35.9s2.36,26.88,7.07,37.12c4.71,10.25,11.65,18.04,20.81,23.39,8.39,4.91,18.6,7.53,30.57,7.94,1.09.04,38.16.08,39.27.08h51.96v-45.15h-92.63v-32.09h134.52v87.38c0,12.46-9.91,22.5-22.37,22.5h0s-287.35.14-287.35.14c-14.49.02-26.14,13.21-26.14,28.08,0,4.21.77,8.65,2.59,11.79.08.14.22.36.37.61,49.43,81.3,141.66,140.51,243.73,140.51,155.61,0,281.75-126.14,281.75-281.75,0-23.65-2.95-46.59-8.44-68.54h-81.72c-10.3.67-19.05,3.66-26.24,8.95ZM347.97,222.62c-11.55,0-20.92-9.37-20.92-20.92s9.37-20.92,20.92-20.92,20.92,9.37,20.92,20.92-9.37,20.92-20.92,20.92Z";

const MARK_T =
  "M542.89,181.13c3.99,10.42,7.39,21.11,10.14,32.08h49.98v169.17h19.45c11.91,0,21.59-9.05,22.43-20.72v-148.44h63.91v-32.08h0s-165.91,0-165.91,0Z";

/**
 * The GFT logo, inlined rather than an <img src="*.svg"> — browsers
 * (Safari in particular) may pre-rasterize an SVG image at a heuristic size
 * and rescale it, fuzzing the curve edges; inline SVG always renders as
 * vectors at device resolution. Same paths as public/gft-logo*.svg.
 */
export function GftLogo({
  variant = "color",
  className,
}: {
  /** "white" for dark surfaces (the nav), "color" for light ones. */
  variant?: "color" | "white";
  className?: string;
}) {
  const mark = variant === "white" ? "#fff" : "#46236a";
  return (
    <svg
      viewBox="0 0 708.8 563.5"
      width="708.8"
      height="563.5"
      role="img"
      aria-label="GFT"
      className={className}
    >
      <path fill="#f7941d" d={HEART} />
      <path fill={mark} d={MARK} />
      <path fill={mark} d={MARK_T} />
    </svg>
  );
}
